import { usePatchRestaurantSupplierApi } from 'apis/restaurant-suppliers';
import { FormControl, Switch, SwitchProps } from 'design-system';

export interface IRestaurantRelationFlagSwitchCell extends Omit<SwitchProps, 'value'> {
  relationId: number;
  field: 'favorite' | 'isGpoRelation';
  value: boolean;
}

export const RestaurantRelationFlagSwitch = (params: IRestaurantRelationFlagSwitchCell) => {
  const { relationId, field, value, ...rest } = params;
  const { mutate: patchRelation, isLoading } = usePatchRestaurantSupplierApi();

  const handleToggle = () => {
    patchRelation({ relationId, body: { [field]: !value } });
  };

  return (
    <FormControl display='flex' alignItems='center'>
      <Switch
        id={`${field}-${relationId}`}
        onChange={handleToggle}
        isChecked={value}
        isDisabled={isLoading}
        {...rest}
      />
    </FormControl>
  );
};
